import React from 'react';

const CoinCrypto = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "17",
    viewBox: "0 0 19 17",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.8543 8.11751C14.3793 7.50418 14.6901 6.7225 14.6901 5.83335C14.6901 4.18001 13.5609 2.78417 12.0234 2.39334V0.5H10.2459V2.2775H8.46761V0.5H6.69011V2.2775H4.02344V4.05583H5.80094V12.9442H4.02344V14.7225H6.69011V16.5H8.46761V14.7225H10.2459V16.5H12.0234V14.7225C13.9876 14.7225 15.5793 13.1308 15.5793 11.1667C15.5793 9.87748 14.8859 8.74002 13.8543 8.11751ZM7.57929 4.05581H11.1343C12.1126 4.05581 12.9126 4.85581 12.9126 5.83331C12.9126 6.8108 12.1126 7.6108 11.1343 7.6108H7.57929V4.05581ZM12.0235 12.9442H7.57929V9.38915H12.0235C13.001 9.38915 13.801 10.1892 13.801 11.1667C13.801 12.1441 13.001 12.9442 12.0235 12.9442Z",
      fill: "#E8E8E8"
    }
  )
);
CoinCrypto.displayName = "Icons.CoinCrypto";

export { CoinCrypto };
//# sourceMappingURL=CoinCrypto.js.map
